<template>
    <div>
        <div class="fheader">
            <div class="ftop">
                <div class="gb">
                    <van-tabs  v-model="active" class="gbtab" style="justify-content: center;" @click="changemytab"  :color="$abctheme.basecolor" :sticky="true" line-width="23px" :title-active-color="$abctheme.basecolor" swipeable>
                        <van-tab title="育儿"  :title-style="{'margin-left': '25vw','width':'80px','flex':'0 0 auto','font-size':'17px'}">
                            <cmy :item="myinfo"></cmy>
                        </van-tab>
                        <van-tab title="社区"  :title-style="{'width':'80px','flex':'0 0 auto','font-size':'17px'}">
                            <div class="mytabs">
                                <van-tabs color="#000" v-model="navindex" ref="mytabs" @click="changetab" :sticky="true" offset-top="44px"   line-width="0"  line-height="0" :title-active-color="$abctheme.basecolor" title-inactive-color="#8d8d8d" >
                                    <!-- <van-tab title="关注"></van-tab> -->
                                    
                                    <van-tab :title="navitem.title"  v-for="(navitem,index) in navlist" :key="index">
                                        <van-pull-refresh v-model="navitem.refreshing" @refresh="onRefresh">
                                            <van-list
                                                v-model="navitem.loaded"
                                                :finished="navitem.loadingType == 'nomore' ? true : false"
                                                :finished-text="navitem.loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
                                                @load="loadData"
                                            >
                                            <div v-if="index==0">
                                                <div v-for="(item,zindex) in navitem.list" :key="zindex">
                                                    <comrecommend :item="item" @Attention="Attention1" @like="like"></comrecommend>
                                                </div>
                                            </div>
                                            <div v-if="index==1">
                                                <div v-for="(item,zindex) in navitem.list" :key="zindex">
                                                    <comrecommend :item="item" @Attention="Attention" @like="like"></comrecommend>
                                                </div>
                                            </div>

                                            <div v-if="index==2">
                                                <div v-if="navitem.list.length>0">
                                                    <div v-for="(zitem,zindex) in navitem.list" :key="zindex">
                                                        <comanswer :item="zitem"></comanswer>
                                                    </div>
                                                </div>
                                                
                                            </div>

                                            </van-list>
                                        </van-pull-refresh>
                                    </van-tab>
                                    <!-- <van-tab title="视频"></van-tab> -->
                                    <van-tab title="我的" name="a3" >

                                    </van-tab>
                                </van-tabs>
                            </div>
                        </van-tab>
                    </van-tabs>
                </div>
                 
                <!-- <div class="righticon">
                    <van-icon name="search" class="righticon-icon" size="20"/>
                </div> -->
            </div>
            
            
        </div>
        
            <van-popover
                v-model="showPopover"
                trigger="click"
                theme="dark"
                :actions="actions"
                @select="onSelect"
                placement="top-end"
                class="mfbtn"
                v-if="active==1"
                >
                <template #reference>
                    <div class="mfbtn-mbg">
                        <van-icon
                        class="mfbtn-mbg-icon"
                        :size="18"
                        color="#fff"
                        class-prefix="abc-icon"
                        name="xieru_xi"
                    />
                </div>     
                </template>
            </van-popover>
        
        <navigate v-if="!userinfo.memberLevelModel.isRetail" />
        <retailfooter v-if="userinfo.memberLevelModel.isRetail"></retailfooter>
    </div>
</template>
<script>

import comrecommend from '@/components/common/recommend/comrecommend.vue';
import comanswer from '@/components/common/answer/comanswer.vue';
import cmy from '@/components/common/cmy.vue';
import Util from '@/config/Util';
export default {
    components:{
        comrecommend,
        comanswer,
        cmy
    },
    data(){
        return{
            imageshow:false,
            myimages:[],
            active:0,
            mactive:0,
            navindex:0,
            showPopover: false,
            // 通过 actions 属性来定义菜单选项
            actions: [ 
                { text: '发话题'},
                { text: '提问' },
            ],
            navlist: [
                {
                    title:'关注',
                    loadingType: "more",
                    loaded: false,
                    refreshing:false,
                    getparams: {
                        sorting: " sorter desc,id desc",
                        maxResultCount: 10,
                        skipCount: 0,
                        dealerId:undefined,
                        isAttention:true,
                    },
                    list: [],
                },
                {
                    title:'推荐',
                    loadingType: "more",
                    loaded: false,
                    refreshing:false,
                    getparams: {
                        sorting: " sorter desc,id desc",
                        maxResultCount: 10,
                        skipCount: 0,
                        isRecommend:true
                    },
                    list: [],
                },
                {
                    title:'问答',
                    loadingType: "more",
                    loaded: false,
                    refreshing:false,
                    getparams: {
                        sorting: " sorter desc,id desc",
                        maxResultCount: 10,
                        skipCount: 0,
                    },
                    list: [],
                }
            ],
            loading: false,
            finished: false,
            refreshing: false,
            myinfo:undefined,
            userinfo:undefined
        }
    },
    created(){
        //检测一下 是否已经创建过用户
        
        this.userinfo=Util.abp.userInfo;
        console.log(this.userinfo);
        this.ajax.post('/api/services/app/PhoneMemberPersonal/QueryPersonal').then(x=>
        {
            if(!x.result)
            {
                this.$router.push({path:'/updatemyinfo'});
            }
            this.myinfo=x.result;
        })
        
        if(window.uactive!=undefined&&window.mactive!=undefined)
        {
            this.active=window.uactive;
            this.navindex=window.mactive;
        }
    },
    methods:{
        Attention1(item)
        {
            var vindex=this.navlist[0].list.findIndex(x=>x.id==item.id);
            if(!item.isAttention)
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/Attention?AttentionId='+item.memberPersonalId).then(x=>{
                     this.loadData("refresh");
                })
            }
            else
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/CancelAttention?AttentionId='+item.memberPersonalId).then(x=> {
                         this.loadData("refresh");
                })
            }
        },
        Attention(item)
        {
            var vindex=this.navlist[1].list.findIndex(x=>x.id==item.id);
            if(!item.isAttention)
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/Attention?AttentionId='+item.memberPersonalId).then(x=>{
                    this.navlist[1].list.forEach(x=>
                    {
                        if(x.memberPersonalId==item.memberPersonalId)
                        {
                            x.isAttention=true;
                        }
                    })
                    this.navlist[0].loadingType="refresh";

                })
            }
            else
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/CancelAttention?AttentionId='+item.memberPersonalId).then(x=> {
                    this.navlist[1].list.forEach(x=>
                    {
                        if(x.memberPersonalId==item.memberPersonalId)
                        {
                            x.isAttention=false;
                        }
                    })
                    this.navlist[0].loadingType="refresh";
                    this.navlist[0].loaded=false;
                })
            }

        },
        changemytab(name){
            
            if(!this.myinfo&&this.active==1)
            {
                this.$router.push({path:'/updatemyinfo'});
            }
            if(this.active==1)
            {
                window.uactive=this.active;
                window.mactive=this.navindex;
            }
            if(this.active==0)
            {
                window.uactive=undefined;
                window.mactive=undefined;
            }

        },
        onRefresh() {
            this.loadData("refresh");
        },
        loadData(source) {
        
        let navItem = this.navlist[this.navindex];
        // let state = navItem.state;

        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
                return;
            }
        }

        if (source === "refresh") {
            this.navlist[this.navindex].list = [];
            this.navlist[this.navindex].getparams.skipCount = 0;
        }

        if(navItem.loadingType=="refresh")
        {
            this.navlist[this.navindex].list = [];
            this.navlist[this.navindex].getparams.skipCount = 0;
        }

        this.navlist[this.navindex].loadingType = "loading";
        var params = navItem.getparams;
        
        var url="/api/services/app/PhoneTopic/QueryTopicList";
        if(this.navindex==2)
        {   
            url="/api/services/app/PhoneQuestion/QueryQuestionList";
        }
        //加载数据
        this.ajax
            .post(url, params)
            .then((x) => {
            this.navlist[this.navindex].getparams.skipCount += this.navlist[this.navindex].getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navlist[this.navindex].list = this.navlist[this.navindex].list.concat(x.result.items);
            console.log(this.navlist);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navlist[this.navindex].loadingType =
                totalcount > this.navlist[this.navindex].getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
                this.$set(this.navlist[this.navindex], "loaded", false);
                this.navlist[this.navindex].refreshing = false;
            });
        },
        onSelect(action,index) {
            
            if(index==0)
            {
                this.$router.push({path:'/addrecommend'})
            }
            if(index==1)
            {
                 this.$router.push({path:'/addquestion'})
            }
        },
        changetab(name,tit)
        {
            if(name=='a3')
            {
                this.goto('/communitymy');
                // window.mactive=0;
            }
            else
            {
                if(this.navindex==0)
                {
                    this.navlist[0].loadingType="refresh";
                    this.loadData();
                }
                window.mactive=this.navindex;
            }
        },
        goto(url){
            this.$router.push({path:url});
        },
        like(item)
        {
            var vindex=this.navlist[1].list.findIndex(x=>x.id==item.id);
            if(!item.isLike)
            {
                var model={
                    topicId:item.id
                };
                this.ajax.post('/api/services/app/PhoneTopic/LikeTopic',model).then(x=>{
                    this.navlist[1].list[vindex].isLike=true;
                    this.navlist[1].list[vindex].giveLikeCount+=1;
                })
            }
            else
            {
                
                this.ajax.post('/api/services/app/PhoneTopic/CancelTopic?topicId='+item.id).then(x=> {
                    this.navlist[1].list[vindex].isLike=false;
                    this.navlist[1].list[vindex].giveLikeCount-=1;
                })
            }
        }
    }
}
</script>
<style  scoped>
.fheader{
    text-align: center;
    
    position: relative;
}
.ftop{
    position: relative;
    
}

.gbtab .van-tabs__nav--line{
    justify-content: center;
}
.righticon{
    position: fixed;
    right: 10px;
    height: 44px;
    top:0;
    z-index: 9999999;
}
.righticon-icon{
    position: relative;
    top:10px;
}

.mfbtn{
    position: fixed;
    bottom: 70px;
    right: 20px;
    line-height: 32px;
    padding: 3px;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background-color: #FDD108;
}
.mfbtn-mbg{
        position: relative;
        width: 100%;
        height: 100%;
}
.mfbtn-mbg-icon{
    position: absolute;
    top:50%;
    left:25%;
    transform: translate(0,-50%);
}


</style>